export const appConfig = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL as string | undefined,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined,
  demoMode: String(import.meta.env.VITE_ESTUFA_DEMO_MODE ?? "false") === "true",
  timezone: String(import.meta.env.VITE_ESTUFA_TIMEZONE ?? "America/Sao_Paulo"),
};

export const hasSupabaseConfig = Boolean(appConfig.supabaseUrl && appConfig.supabaseAnonKey);
